export const navigateToAddStpDetails = ({
  dispatch = () => {},
  navigate = () => {},
}) => {
  dispatch({
    type: 'SET_IS_PAINT_FLOW',
    data: true,
  });
  navigate('/order-booking/select-ship-to-party');
};
